// @ts-nocheck


import React from 'react';
import CommonListPage from '../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';

import { connect } from 'react-redux';
import {
  maintenanceOperationGroupApi,
  maintenanceOperationApi } from
'../../lib/api';
import { HeaderTabs } from './components';
import { navigate } from '../../lib/routerAdapter';

import { accessTypeEnum } from './../../lib/enum';

const columns = [
{ title: 'Код работы', dataIndex: 'code', key: 'code' },
{ title: 'Наименование', dataIndex: 'name', key: 'name' },
{ title: 'Норма-часы', dataIndex: 'hours', key: 'hours' }];




const addAccess = [
accessTypeEnum.admin,
accessTypeEnum.handlingMaintenanceOperationGroups];

const access = {
  add: () => navigate(`/admin/maintenance-operations/new/`)
};
const MaintenanceOperationsTable = ({ userAccess }) => {
  const onFetch = async (params) => {
    return await maintenanceOperationGroupApi.fetchMaintenanceOperationGroups(
      params
    );
  };
  const onDelete = async (id) => {
    return await maintenanceOperationApi.deleteMaintenanceOperation(id);
  };
  const canAdd = () => userAccess.some((access) => addAccess.includes(access));
  return (
    <Page>
      <CommonListPage
        pageHeaderProps={{
          mainHeader: 'Перечень работ по ремонту ТС',
          access
        }}
        subHeader={<HeaderTabs selectedTab="general" />}
        tableListProps={{
          columns,
          onSelect: (id) =>
          navigate(`/admin/maintenance-operations/${id}`),
          canDelete: canAdd()
        }}
        oldCrud={{ onFetch, onDelete }} />

    </Page>);

};

export default connect((state) => ({
  maintenanceOperationGroups: state.maintenanceOperationGroups,
  userAccess: state.auth.profile.access
}))(MaintenanceOperationsTable);
